import { FC } from 'react';

// @ts-ignore
import profilePlaceholderIcon from "assets/images/priorities/profile-placeholder.svg";

import {
  Wrapper,
  ProfilePicture,
  Name,
  Email,
  Link
} from "./styled";

import { APM_PATH, COACHING_PATH } from 'utils/routes';

export interface IClient {
  id: string;
  display_picture: string;
  name: string;
  email: string;
}

interface IProps {
  data: IClient;
}

const UserRow: FC<IProps> = ({ data }) => {
  const { id, display_picture, name, email } = data;

  return (
    <Wrapper>
      <ProfilePicture src={display_picture || profilePlaceholderIcon} alt="" />
      <Name>{name}</Name>
      <Email>{email}</Email>

      <Link to={`${APM_PATH}${COACHING_PATH}/${id}`}>Enter</Link>
    </Wrapper>
  );
}

export default UserRow;
